__turbopack_context__.v({
  "desc": "ReviewSection-module-scss-module__wczYeq__desc",
  "heading": "ReviewSection-module-scss-module__wczYeq__heading",
  "ratings": "ReviewSection-module-scss-module__wczYeq__ratings",
  "reviews-content": "ReviewSection-module-scss-module__wczYeq__reviews-content",
});
